/* Guía de fabricación: de momento solo cocktails con pasos rellenados en el admin.
 * Compartido por AdminOrders (kanban) y el dashboard de servicio (OrderCard). */

export function itemGuide(it) {
  const p = it?.productId;
  if (!p || p.category !== 'cocktails') return null;
  const steps = Array.isArray(p.prepGuide) ? p.prepGuide.filter(Boolean) : [];
  return steps.length ? { name: it.nameSnapshot || p.name, steps } : null;
}

export default function GuideModal({ guide, onClose }) {
  return (
    <div className="np-backdrop" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="np-modal ko-guide-modal">
        <div className="np-modal-head">
          <h3>Guía · {guide.name}</h3>
          <button type="button" className="np-close" onClick={onClose}>✕</button>
        </div>
        <ol className="ko-guide-steps">
          {guide.steps.map((s, i) => <li key={i}>{s}</li>)}
        </ol>
      </div>
    </div>
  );
}
